import { cloneDeep } from 'lodash'

import Actions from '@sigma-legacy-libs/essentials/lib/utils/Actions'

import { conditionValueTypes } from '@/utils'

import { baseClass, getRuleMainPropsOverrides, resolveRuleMainComponent, ruleTags, ruleTypes } from '@/components/rules/utils'

import render from './render'

export default {
  name: 'RulesDialogMain',

  props: {
    value: null,

    tag: {
      type: String,
      default: undefined,
      validator: value => {
        return ~Object.values(ruleTags).indexOf(value)
      }
    },

    ruleType: {
      type: String,
      default: ruleTypes.conditions,
      validator: value => {
        return ~Object.values(ruleTypes).indexOf(value)
      }
    },

    readonly: Boolean
  },

  data() {
    return {
      proxy: this.value
    }
  },

  computed: {
    $_component() {
      return resolveRuleMainComponent({
        tag: this.tag,
        ruleType: this.ruleType,
        readonly: this.readonly
      })
    },

    $_props() {
      const props = {
        value: this.proxy,
        label: this.getTranslate(`${baseClass}.labels.${this.tag}`),
        disabled: this.disabled,
        dense: true,
        details: false,
        rounded: true,
        autofocus: true,
        clearable: true,
        readonly: this.readonly
      }

      const propsOverrides = getRuleMainPropsOverrides(this.tag)
      if (propsOverrides) {
        Object.assign(props, propsOverrides)
      }

      return props
    },

    $_on() {
      return {
        input: event => {
          this.proxy = event
        }
      }
    },

    defaultValue() {
      if (this.ruleType === ruleTypes.actions) {
        const actionValueType = Actions.tagsMeta[this.tag]?.valueValidator?.type
        switch (actionValueType) {
          case 'object': return {}
          case 'array': return []
          default: return undefined
        }
      }

      const conditionValueType = conditionValueTypes[this.tag]
      switch (conditionValueType) {
        case 'object': return {}
        case 'array': return []
        default: undefined
      }
    }
  },

  watch: {
    value: {
      handler(value) {
        this.proxy = value
      },
      deep: true
    },
    proxy: {
      handler(value) {
        this.$emit('input', value)
      },
      deep: true
    },

    tag() {
      this.setProxy()
    }
  },

  mounted() {
    this.setProxy()
  },

  methods: {
    setProxy() {
      this.proxy = this.defaultValue
      if (this.value) {
        this.proxy = this.value
      }
    },

    reset() {
      this.proxy = cloneDeep(this.defaultValue)
    }
  },

  render
}
